import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { Menu, X, Phone, MessageCircle } from "lucide-react";
import { SITE } from "@/config/site";
import logoAssetUrl from "@/assets/izhub-logo-transparent.webp";
const logoAsset = { url: logoAssetUrl };


const nav = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/our-work", label: "Our Work" },
  { to: "/pricing", label: "Pricing" },
  { to: "/service-areas", label: "Service Areas" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
] as const;

const secondaryNav = [
  { to: "/join-as-a-cleaner", label: "Join as a Cleaner" },
] as const;

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-border/60 bg-background/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full max-w-[1500px] items-center justify-between px-4 md:h-20 md:px-6">
        <Link to="/" className="flex shrink-0 items-center" onClick={() => setOpen(false)} aria-label="IZHUB Cleaning Services home">
          <img
            src={logoAsset.url}
            alt="IZHUB Cleaning Services logo"
            className="h-11 w-auto md:h-12 lg:h-12 xl:h-16 object-contain"
            width={220}
            height={124}
            fetchPriority="high"
            decoding="async"
          />
        </Link>


        <nav className="hidden lg:flex min-w-0 items-center gap-2.5 xl:gap-5 2xl:gap-6">
          {nav.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className="nav-link whitespace-nowrap text-xs xl:text-sm text-foreground/75 transition-colors hover:text-primary"
              activeProps={{ className: "is-active text-primary font-medium" }}
              activeOptions={{ exact: n.to === "/" }}
            >
              {n.label}
            </Link>
          ))}
          {secondaryNav.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className="nav-link whitespace-nowrap text-xs xl:text-sm text-foreground/60 transition-colors hover:text-primary"
              activeProps={{ className: "text-primary font-medium" }}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex shrink-0 items-center gap-2 xl:gap-2.5 2xl:gap-3">
          <a href={SITE.whatsapp} target="_blank" rel="noreferrer" className="btn-whatsapp whitespace-nowrap text-xs xl:text-sm !px-2.5 xl:!px-4 !py-2" aria-label="WhatsApp Us">
            <MessageCircle className="h-4 w-4 shrink-0" /> WhatsApp Us
          </a>
          <a href={`tel:${SITE.phone}`} className="btn-outline whitespace-nowrap text-xs xl:text-sm !px-2.5 xl:!px-4 !py-2">
            <Phone className="h-4 w-4 shrink-0" /> {SITE.phoneDisplay}
          </a>
          <Link to="/quote" className="btn-primary whitespace-nowrap text-xs xl:text-sm !px-3 xl:!px-5 !py-2 xl:!py-2.5">Get a Quote</Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden grid h-10 w-10 place-items-center rounded-full border border-border"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-background">
          <div className="container-x py-4 flex flex-col gap-1">
            {nav.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-base text-foreground/85 hover:bg-muted"
                activeProps={{ className: "bg-muted text-primary font-medium" }}
                activeOptions={{ exact: n.to === "/" }}
              >
                {n.label}
              </Link>
            ))}
            <div className="my-2 h-px bg-border" />
            {secondaryNav.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-base text-foreground/70 hover:bg-muted"
                activeProps={{ className: "bg-muted text-primary font-medium" }}
              >
                {n.label}
              </Link>
            ))}
            <div className="mt-3 grid grid-cols-2 gap-2">
              <a href={SITE.whatsapp} target="_blank" rel="noreferrer" className="btn-whatsapp text-sm">
                <MessageCircle className="h-4 w-4" /> WhatsApp Us
              </a>
              <a href={`tel:${SITE.phone}`} className="btn-outline text-sm col-span-2">
                <Phone className="h-4 w-4" /> Call {SITE.phoneDisplay}
              </a>
            </div>
            <Link to="/quote" onClick={() => setOpen(false)} className="btn-primary text-sm w-full mt-2">Get a Quote</Link>
          </div>
        </div>
      )}
    </header>
  );
}
